"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DATE_FORMAT = exports.CUSTOM_DATE_FORMAT = void 0;

var _SimpleStagedObject = _interopRequireDefault(require("redux-less/SimpleStagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var CUSTOM_DATE_FORMAT = 'customDateFormat';
exports.CUSTOM_DATE_FORMAT = CUSTOM_DATE_FORMAT;
var DATE_FORMAT = 'dateFormat';
exports.DATE_FORMAT = DATE_FORMAT;
var properties = [{
  type: _PropertyTypes.default.SIMPLE,
  key: DATE_FORMAT,
  initialValue: ''
}];
var CustomDateFormat = new _SimpleStagedObject.default({
  stagedSelector: function stagedSelector(state) {
    return state.modules.website.blogs.staging.customDateFormat;
  },
  properties: properties,
  objectType: CUSTOM_DATE_FORMAT,
  namespace: 'blogs'
});
var _default = CustomDateFormat;
exports.default = _default;